import React, { useState, useContext, useEffect } from "react";
import { ServicesContainer } from "./AboutElements";
import * as PA from "./AboutElements";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";
import { withRouter } from "react-router-dom";
import AbFull from "../../../../images/about-full.png";
import AbFirstHalf from "../../../../images/about-firsthalf.png";
import AbSeondHalf from "../../../../images/about-secondhalf.png";
import BedroomIcon from "../../../../images/bedroom.png";
import ParkedIcon from "../../../../images/parked-car.png";
import SquareFtIcon from "../../../../images/squareft.png";
import { LanguageContext } from "../../../../utils/language/Language";

const Services = ({ userData, history }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(window.localStorage.getItem("rcml-lang") || "en");
  const { dictionary } = useContext(LanguageContext);
  const [currentPos, setCurrentPos] = useState(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((currentPos) => {
      setCurrentPos({
        lat: currentPos.coords.latitude,
        lng: currentPos.coords.longitude,
      });
    });
  }, []);

  return (
    <ServicesContainer id="services">
      <PA.AbMainBox>
        <PA.AbLeftBox>
          <PA.AboutText>{dictionary.menzilString.About_Us} </PA.AboutText>
          
          {/* <PA.AbHowText>
          {dictionary.menzilString.How} <PA.MainDesc>{dictionary.menzilString.Menzill}</PA.MainDesc> {dictionary.menzilString.Works}
          </PA.AbHowText> */}
          <PA.AbHowDesc>
          {dictionary.menzilString.About_desc}
          </PA.AbHowDesc>
         
          <PA.AbPointBox>
            <PA.AbPointSingle>
              <PA.Abdash>&#8213;</PA.Abdash>
              <PA.AbdashText>{dictionary.menzilString.Discover_Home}</PA.AbdashText>
            </PA.AbPointSingle>
            <PA.AbPointSingle>
              <PA.Abdash>&#8213;</PA.Abdash>
              <PA.AbdashText>{dictionary.menzilString.Get_Leads}</PA.AbdashText>
            </PA.AbPointSingle>
            <PA.AbPointSingle>
              <PA.Abdash>&#8213;</PA.Abdash>
              <PA.AbdashText>{dictionary.menzilString.Agent_Finder}</PA.AbdashText>
            </PA.AbPointSingle>
            <PA.AbPointSingle>
              <PA.Abdash>&#8213;</PA.Abdash>
              <PA.AbdashText>{dictionary.menzilString.Buyback_Gurantee}</PA.AbdashText>
            </PA.AbPointSingle>
          </PA.AbPointBox>
          {/* <PA.CheckPropertyBtn>
            <PA.ViewBtn
            onClick={() => {
                history.push(`/search-property?lat=${currentPos.lat}&long=${currentPos.lng}&sale_type=1&property_type=A`);
               }}
            >{dictionary.menzilString.Check_Properties}</PA.ViewBtn>
          </PA.CheckPropertyBtn> */}
        </PA.AbLeftBox>
        <PA.AbRightBox>
          <PA.Image1>
            <PA.CommonImage src={AbFull} />
          </PA.Image1>
          <PA.Image2>
            <PA.CommonImage src={AbFirstHalf} />
          </PA.Image2>
          <PA.Image3>
            <PA.CommonImage src={AbSeondHalf} />
          </PA.Image3>
        </PA.AbRightBox>
      </PA.AbMainBox>
    </ServicesContainer>
  );
};

// export default Services;
const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Services));
